import * as types from './types';
import { createAction } from '../../models/redux/CreateAction';

export const collapseSidebar = payload => {
  return createAction(types.APP_COLLAPSE_SIDEBAR, payload);
};
